module.exports = __webpack_public_path__ + "static/datasapiens-typephysics-a3e4b4031407174765b14b70d2ac90ed.mp4";